import React from "react";
import root from "react-shadow";
const FloorplanSVG = (props: {
  svg: string;
  vpbPkid: number;
  layerIds: string[];
  visibleLayers: string[];
}) => {
  const getLayerStyles = () => {
    return props.layerIds.map((layerId) => {
      if (props.visibleLayers.indexOf(layerId) > -1) {
        return `[id$="${layerId}"] { display: block; } `;
      }
      return `[id$="${layerId}"] { display: none; } `;
    });
  };

  return (
    <root.div>
      <div
        className={"svg-container"}
        dangerouslySetInnerHTML={{ __html: props.svg }}
      />
      <style>
        {`.svg-container svg {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
        }
        svg > g { display: none; }
        svg > g:first-of-type { display: block; }
        svg > g[id$="Base"] { display: block; }
      `}
      </style>
      <style>{getLayerStyles()}</style>
    </root.div>
  );
};

export default FloorplanSVG;
